import React, {ChangeEventHandler, FC, useId} from "react"
import CheckBox from "../elements/CheckBoxButton"
import {useFormData} from "../../states/FormData"
import FlexDiv from "../elements/FlexDiv";
import styled from "styled-components";

const Step3: FC = () => {

    const { setFormData, topicForbiddenFoods, topicSuperfoods, topicNausea, topicSupplements,
        topicSport, topicVegetarian, topicVegan, topicWeight, topicEasyBirth} = useFormData()

    const changeHandler: ChangeEventHandler<HTMLInputElement> = (event) => setFormData(event.target.name, event.target.checked)

    return (
        <>
            <span className={"survey-heading"}>Welche Themen interessieren dich außerdem?</span>
            <FlexDiv>
                <CheckBox name={"topicForbiddenFoods"} checked={topicForbiddenFoods} onChange={changeHandler} label={"Verbotene Lebensmittel"} />
                <CheckBox name={"topicSuperfoods"} checked={topicSuperfoods} onChange={changeHandler} label={"Superfoods"} />
                <CheckBox name={"topicNausea"} checked={topicNausea} onChange={changeHandler} label={"Übelkeit"} />
                <CheckBox name={"topicSupplements"} checked={topicSupplements} onChange={changeHandler} label={"Nahrungs&shy;ergänzungsmittel"} />
                <CheckBox name={"topicSport"} checked={topicSport} onChange={changeHandler} label={"Sport"} />
                <CheckBox name={"topicVegetarian"} checked={topicVegetarian} onChange={changeHandler} label={"Vegetarische Ernährung"} />
                <CheckBox name={"topicVegan"} checked={topicVegan} onChange={changeHandler} label={"VEgane Ernährung"} />
                <CheckBox name={"topicWeight"} checked={topicWeight} onChange={changeHandler} label={"Gewichtszunahme & Kontrolle"} />
                <CheckBox name={"topicEasyBirth"} checked={topicEasyBirth} onChange={changeHandler} label={"Lebensmittel & NEM<wbr> für eine leichtere Geburt"} />
            </FlexDiv>
        </>
    )
}

export default Step3